var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptoFunds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_437_2512",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 140
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_437_2512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7496 54.25C44.7496 63.2494 37.6523 70.5912 28.7496 70.9835V37.5165C37.6523 37.9088 44.7496 45.2506 44.7496 54.25Z",
    fill: "#FAFAFA",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_437_2512",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8834 78.75C16.5019 61.6123 32.1531 49 50.7501 49H98.0001C120.23 49 138.25 67.0205 138.25 89.25C138.25 108.475 124.772 124.551 106.75 128.546V140H84.0001V129.5H63.0001V140H40.2501V128.117C26.4598 124.4 15.5997 113.54 11.8834 99.75H1.75006V78.75H11.8834Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8834 78.75C16.5019 61.6123 32.1531 49 50.7501 49H98.0001C120.23 49 138.25 67.0205 138.25 89.25C138.25 108.475 124.772 124.551 106.75 128.546V140H84.0001V129.5H63.0001V140H40.2501V128.117C26.4598 124.4 15.5997 113.54 11.8834 99.75H1.75006V78.75H11.8834Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8834 78.75V80.25H13.0326L13.3317 79.1403L11.8834 78.75ZM106.75 128.546L106.425 127.082L105.25 127.342V128.546H106.75ZM106.75 140V141.5H108.25V140H106.75ZM84.0001 140H82.5001V141.5H84.0001V140ZM84.0001 129.5H85.5001V128H84.0001V129.5ZM63.0001 129.5V128H61.5001V129.5H63.0001ZM63.0001 140V141.5H64.5001V140H63.0001ZM40.2501 140H38.7501V141.5H40.2501V140ZM40.2501 128.117H41.7501V126.967L40.6404 126.668L40.2501 128.117ZM11.8834 99.75L13.3317 99.3597L13.0326 98.25H11.8834V99.75ZM1.75006 99.75H0.250061V101.25H1.75006V99.75ZM1.75006 78.75V77.25H0.250061V78.75H1.75006ZM50.7501 47.5C31.4579 47.5 15.2255 60.5839 10.435 78.3597L13.3317 79.1403C17.7782 62.6408 32.8482 50.5 50.7501 50.5V47.5ZM98.0001 47.5H50.7501V50.5H98.0001V47.5ZM139.75 89.25C139.75 66.1921 121.058 47.5 98.0001 47.5V50.5C119.401 50.5 136.75 67.849 136.75 89.25H139.75ZM107.075 130.011C125.769 125.867 139.75 109.193 139.75 89.25H136.75C136.75 107.756 123.776 123.236 106.425 127.082L107.075 130.011ZM108.25 140V128.546H105.25V140H108.25ZM84.0001 141.5H106.75V138.5H84.0001V141.5ZM82.5001 129.5V140H85.5001V129.5H82.5001ZM63.0001 131H84.0001V128H63.0001V131ZM64.5001 140V129.5H61.5001V140H64.5001ZM40.2501 141.5H63.0001V138.5H40.2501V141.5ZM38.7501 128.117V140H41.7501V128.117H38.7501ZM10.435 100.14C14.2905 114.447 25.5536 125.71 39.8597 129.565L40.6404 126.668C27.3661 123.091 16.909 112.634 13.3317 99.3597L10.435 100.14ZM11.8834 98.25H1.75006V101.25H11.8834V98.25ZM3.25006 99.75V78.75H0.250061V99.75H3.25006ZM1.75006 80.25H11.8834V77.25H1.75006V80.25Z",
    fill: "black",
    mask: "url(#path-3-inside-1_437_2512)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.8751,
    cy: 73.5,
    r: 2.75,
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.875,
    y: -10.625,
    width: 45.75,
    height: 100.875,
    fill: "#FAFAFA",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "2.62 2.62"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.7495,
    cy: 88.3184,
    r: 23.625,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9875 98.9454C77.2515 98.9454 75.8048 98.6654 74.6475 98.1054C73.5088 97.5454 72.6502 96.7707 72.0715 95.7814C71.4928 94.7734 71.1942 93.616 71.1755 92.3094H74.2835C74.3022 93.168 74.4795 93.924 74.8155 94.5774C75.1515 95.212 75.6648 95.7067 76.3555 96.0614C77.0648 96.3974 77.9702 96.5654 79.0715 96.5654C80.3968 96.5654 81.4702 96.304 82.2915 95.7814C83.1315 95.24 83.5515 94.428 83.5515 93.3454C83.5515 92.7294 83.4582 92.2254 83.2715 91.8334C83.0848 91.4227 82.7955 91.0774 82.4035 90.7974C82.0115 90.5174 81.4888 90.284 80.8355 90.0974C80.1822 89.892 79.3795 89.7054 78.4275 89.5374C77.3635 89.3507 76.4115 89.1174 75.5715 88.8374C74.7315 88.5574 74.0128 88.212 73.4155 87.8014C72.8368 87.372 72.3888 86.84 72.0715 86.2054C71.7728 85.552 71.6235 84.768 71.6235 83.8534C71.6235 82.6587 71.9128 81.632 72.4915 80.7734C73.0702 79.896 73.9008 79.224 74.9835 78.7574C76.0662 78.2907 77.3635 78.0574 78.8755 78.0574C80.3688 78.0574 81.6475 78.3094 82.7115 78.8134C83.7755 79.2987 84.5968 79.9894 85.1755 80.8854C85.7542 81.7627 86.0528 82.808 86.0715 84.0214H82.9915C82.9728 83.2 82.7768 82.5187 82.4035 81.9774C82.0488 81.436 81.5542 81.0347 80.9195 80.7734C80.3035 80.512 79.5848 80.3814 78.7635 80.3814C77.9235 80.3814 77.2048 80.512 76.6075 80.7734C76.0288 81.016 75.5715 81.3707 75.2355 81.8374C74.9182 82.2854 74.7595 82.8267 74.7595 83.4614C74.7595 84.2267 74.9275 84.8147 75.2635 85.2254C75.6182 85.6174 76.1688 85.9347 76.9155 86.1774C77.6808 86.4014 78.6888 86.6347 79.9395 86.8774C80.8168 87.0267 81.6568 87.2227 82.4595 87.4654C83.2622 87.6894 83.9808 88.016 84.6155 88.4454C85.2502 88.8747 85.7542 89.4627 86.1275 90.2094C86.5008 90.9374 86.6875 91.8894 86.6875 93.0654C86.6875 94.2227 86.3982 95.2494 85.8195 96.1454C85.2408 97.0227 84.3728 97.7134 83.2155 98.2174C82.0768 98.7027 80.6675 98.9454 78.9875 98.9454ZM77.8955 101.073V75.9014H79.9955V101.073H77.8955Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoFunds);
export default __webpack_public_path__ + "static/media/crypto_funds.b0773d564b2815806907a3dcacbbde1d.svg";
export { ForwardRef as ReactComponent };